import React from 'react'
import ClickableChips from '../../../section/notifications/ClickableChips'

function ViewAdvisorNotifications() {
  return (
    <ClickableChips />
  )
}

export default ViewAdvisorNotifications